export default __webpack_public_path__ + "media/zurb/img/events/wired/raft/raft-thumb-3aade8835e81bf843c95a3ab63f75a27.png";